/** Users — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import {
  USER_STATUS,
  createUserSchema,
  type CreateUserInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "../projects/_shared";
import { FormGrid, SelectField, TextField } from "../projects/_form";

const adminCreateUserSchema = createUserSchema.extend({
  password: z.string().min(8).max(1024),
});

type AdminCreateUserInput = CreateUserInput & { password: string };

export function UserCreate() {
  const form = useForm<AdminCreateUserInput, any, AdminCreateUserInput>({
    resolver: zodResolver(adminCreateUserSchema),
    defaultValues: {
      email: "",
      display_name: "",
      status: "active",
      password: "",
    },
    refineCoreProps: { resource: "users", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="New User" description="Create a user account." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">User details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="display_name"
                  label="Name"
                  placeholder="Jane Doe"
                />
                <TextField
                  control={control}
                  name="email"
                  label="Email"
                  type="email"
                  placeholder="jane@example.com"
                />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={USER_STATUS}
                />
                <TextField
                  control={control}
                  name="password"
                  label="Initial password"
                  type="password"
                  placeholder="At least 8 characters"
                />
              </FormGrid>
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create User"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default UserCreate;
